module.exports = __webpack_public_path__ + "static/media/cc-diners-club.1f9f0490.svg";